// src/components/calendar/MonthView.jsx
import React, { useState } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import CalendarDay from './CalendarDay';

const MonthView = ({ currentDate, events, onEventDrop, onAddClick, onEventClick }) => {
    const [draggedEvent, setDraggedEvent] = useState(null);

    const getDaysInMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };

    const getFirstDayOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    };

    const getDaysInPreviousMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 0).getDate();
    };

    const handleDragStart = (e, event) => {
        e.dataTransfer.setData('text/plain', event.id);
        setDraggedEvent(event);
    };

    const handleDrop = (day) => {
        if (!draggedEvent) return;

        // Calcula la nueva fecha del evento
        const newStart = new Date(day);
        const oldStart = new Date(draggedEvent.date);
        newStart.setHours(oldStart.getHours(), oldStart.getMinutes());

        // Calcula la duración del evento
        const duration = new Date(draggedEvent.end) - new Date(draggedEvent.start);
        const newEnd = new Date(newStart.getTime() + duration);

        // Llama a la función onEventDrop para actualizar el evento
        onEventDrop(draggedEvent.id, newStart, newEnd);
        setDraggedEvent(null);
    };

    const renderCalendarDays = () => {
        const daysInMonth = getDaysInMonth(currentDate);
        const firstDay = getFirstDayOfMonth(currentDate);
        const daysInPreviousMonth = getDaysInPreviousMonth(currentDate);
        const days = [];

        // Agrega los últimos días del mes anterior
        for (let i = firstDay - 1; i >= 0; i--) {
            const day = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, daysInPreviousMonth - i);
            days.push(
                <Grid item key={`prev-${i}`} xs={12 / 7}>
                    <CalendarDay
                        day={day}
                        events={[]}
                        onDrop={handleDrop}
                        onAddClick={onAddClick}
                        onDragStart={handleDragStart}
                        onEventClick={onEventClick} // Pasar correctamente la función
                        isOutsideMonth
                    />
                </Grid>
            );
        }

        // Agrega los días del mes actual
        for (let day = 1; day <= daysInMonth; day++) {
            const currentDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
            const dayEvents = events.filter(event =>
                new Date(event.date).toDateString() === currentDay.toDateString()
            );

            days.push(
                <Grid item key={day} xs={12 / 7}>
                    <CalendarDay
                        day={currentDay}
                        events={dayEvents}
                        onDrop={handleDrop}
                        onAddClick={onAddClick}
                        onDragStart={handleDragStart}
                        onEventClick={onEventClick} // Pasar correctamente la función
                    />
                </Grid>
            );
        }

        // Agrega los primeros días del mes siguiente para completar las 6 filas
        const totalCells = 42; // 6 filas x 7 columnas
        const remainingCells = totalCells - days.length;
        for (let i = 1; i <= remainingCells; i++) {
            const day = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, i);
            days.push(
                <Grid item key={`next-${i}`} xs={12 / 7}>
                    <CalendarDay
                        day={day}
                        events={[]}
                        onDrop={handleDrop}
                        onAddClick={onAddClick}
                        onDragStart={handleDragStart}
                        onEventClick={onEventClick} // Pasar correctamente la función
                        isOutsideMonth
                    />
                </Grid>
            );
        }

        return days;
    };

    return (
        <Grid container spacing={2}>
            {/* Días de la semana */}
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                <Grid item key={day} xs={12 / 7}>
                    <Paper elevation={1} sx={{ p: 2, textAlign: 'center', fontWeight: 'medium' }}>
                        <Typography variant="body1">{day}</Typography>
                    </Paper>
                </Grid>
            ))}
            {/* Días del calendario */}
            {renderCalendarDays()}
        </Grid>
    );
};

export default MonthView;
